import { BundleResourcesPackage } from "resource-system";
import { Texture } from "@pixi/core";
export class BackgroundResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("BackgroundResourcesPackage");
    }
    public get assets_backgrounds_background_png(): Texture {
        return this.resource<Texture>("assets/backgrounds/background.png");
    }
    public get assets_backgrounds_logo_png(): Texture {
        return this.resource<Texture>("assets/backgrounds/logo.png");
    }
}

